const IRD_REGEX = RegExp('^[0-9]{8,9}$');

export const isValidIrdNumber = (irdNumber?: string): boolean => {
  if (!irdNumber) {
    return false;
  }

  // The irdNumber saved in state doesn't include dashes
  const isFormatValid = IRD_REGEX.test(irdNumber);

  if (!isFormatValid) {
    return false;
  }

  return true;
};
